const LoggedInLayout = () => import("../../views/LoggedInLayoutDashBoard.vue");

const DashBoard = r => require.ensure([], () => r(require('./views/Dashboard.vue')))


const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [

    {
      name: 'dashboard',
      path: "/dashboard",
      component: DashBoard
    }
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
